<template>
  <div class="content">
    <h3>{{ $t("titlePages.MonitoringPurchaseSales") }}</h3>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <base-input class="col-md-4">
            <el-date-picker :disabled="$apollo.queries.surveillanceLeads.loading" v-model="StartDate" value-format="yyyy-MM-dd" type="date" :placeholder="$t('table.columns.Startdate').toUpperCase()"></el-date-picker>
          </base-input>
          <base-input class="col-md-4">
            <el-date-picker :disabled="$apollo.queries.surveillanceLeads.loading" v-model="EndDate" value-format="yyyy-MM-dd" type="date" :placeholder="$t('table.columns.Enddate').toUpperCase()"></el-date-picker>
          </base-input>
          <base-input class="col-md-4">
            <el-select filterable class="select-primary"
                       v-model="CategorieSelects.Categorie"
                       placeholder="CATEGORIE"
                       :disabled="$apollo.queries.surveillanceLeads.loading"
            >
              <el-option
                :value="null"
                :label="$t('labels.AallProducts')"
              ></el-option>
              <el-option
                v-for="option in CategorieSelects.ListCategorie"
                class="select-primary"
                :value="option.pk_categorie"
                :label="option.designation.replace(/Ã©/g,'é').toUpperCase()"
                :key="option.pk_categorie">
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div class="row">
          <base-input class="col-md-12">
            <div
              class="surveillance-tags"
              :class="{ 'is-disabled': $apollo.queries.surveillanceLeads.loading }"
              @click="focusTagInput"
            >
              <span
                v-for="(tag, index) in tags"
                :key="tag + index"
                class="surveillance-tag"
              >
                <span class="surveillance-tag-label">{{ tag }}</span>
                <button
                  type="button"
                  class="surveillance-tag-remove"
                  aria-label="Retirer le tag"
                  :disabled="$apollo.queries.surveillanceLeads.loading"
                  @click.stop="removeTag(tag)"
                >&times;</button>
              </span>
              <input
                ref="tagInput"
                v-model="tagInput"
                type="text"
                class="surveillance-tag-input"
                placeholder="TAGS"
                :disabled="$apollo.queries.surveillanceLeads.loading"
                @keyup.enter.prevent="addTag"
              />
            </div>
          </base-input>
        </div>
        <p v-if="periodBlockMessage" class="text-warning mb-2">{{ periodBlockMessage }}</p>
        <p v-if="apiErrorMessage" class="text-warning mb-2">{{ apiErrorMessage }}</p>
        <div class="col-xs-4 text-right">
          <button class="btn btn-market" @click="DownloadCSV">
            <i class="tim-icons icon-cloud-download-93"></i> EXPORT CSV
          </button>
          <base-button
            v-if="$apollo.queries.surveillanceLeads.loading"
            loading
            class="btn btn-default"
          >{{ $t("buttons.BtnLoad").toUpperCase() }}...</base-button>
          <button
            v-else
            class="btn btn-default"
            :disabled="!!periodBlockMessage"
            @click="search"
          >{{ $t("buttons.BtnSearch").toUpperCase() }}</button>
        </div>
      </div>
    </div>
    <card>
      <div class="row">
        <div class="col-xl-1 col-sm-6">
          <base-input>
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-xl-8 col-sm-6">
          <label style="margin-top: 10px; font-size: 0.75rem">{{ $t("labels.Datatable.NbrLinePerPage").toUpperCase() }}</label>
        </div>
        <base-input class="col-xl-3 col-sm-6">
          <el-input
            type="search"
            class="mb-3 search-input"
            clearable
            prefix-icon="el-icon-search"
            :placeholder="$t('buttons.BtnSearch2').toUpperCase()"
            v-model="searchQuery"
            aria-controls="datatables"
          >
          </el-input>
        </base-input>
      </div>
      <el-table :data="searchLeads.slice(from, to)" v-loading="$apollo.queries.surveillanceLeads.loading" row-class-name="booking-table-rows" class="customtable_cmd">



        <el-table-column
          prop='email'
          label="Email"
          minWidth='150'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.email }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='telephone'
          label="Téléphone"
          minWidth='110'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label :style="checkCaptcha(scope.row.captcha)">

              {{ scope.row.telephone }}


              <br>


              {{ scope.row.telephone_status_type }}

            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='time_new_lead'
          label="Première collecte"
          minWidth='110'
          sortable
        >
          <template scope="scope">
            <label style=" " :style="checkCaptcha(scope.row.captcha)">

              <el-tooltip
                content="Date première collect"
                :open-delay="300"
                placement="top"
              >
                <span>{{ scope.row.time_new_lead||scope.row.date_collect  }}</span>
              </el-tooltip>
            </label>
          </template>
        </el-table-column>

        <el-table-column
          prop='date_collect'
          label="Dernière collecte"
          minWidth='110'
           sortable
        >
          <template scope="scope">
            <label style=" " :style="checkCaptcha(scope.row.captcha)">
               <el-tooltip
                content="Date dernière collecte"
                :open-delay="300"
                placement="top"
              >
                <span>{{ scope.row.date_collect }}  </span>
              </el-tooltip>
             </label>
          </template>
        </el-table-column>




        <el-table-column
          prop='lead_type'
          label="Type"
          minWidth='75'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.lead_type }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='subid'
          label="Tag"
          minWidth='150'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.subid }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='societe'
          label="Societé"
          minWidth='150'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.societe }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='date_livraison'
          label="Date livraison"
          minWidth='120'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.date_livraison }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='pk_commande'
          label="Commande"
          minWidth='115'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.pk_commande }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='prix_vente'
          label="Prix de vente (€)"
          minWidth='100'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <template v-if="scope.row.prix_vente === 'OK'">
              {{ scope.row.prix_vente = '' }}
            </template>
            <template v-else>
              <label :style="checkCaptcha(scope.row.captcha)">
                {{ scope.row.prix_vente }}
              </label>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          prop='gamme'
          label="status"
          minWidth='90'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
          

            <label v-if="scope.row.gamme == 'NOPHONE'" style="color: red" :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.gamme }}
            </label>
            <label v-else :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.gamme }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='filtre'
          label="Filtre"
          minWidth='80'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.filtre }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='vendu'
          :label="$t('table.columns.sold')"
          minWidth='80'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label v-if="scope.row.vendu == 'NON'" style="color: red" :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.vendu }}
            </label>
            <label v-else :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.vendu }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='retourws'
          label="Retour ws"
          minWidth='150'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.retourws }}
            </label>
          </template>
        </el-table-column>
        <el-table-column
          prop='captcha'
          label="verify Recapcha"
          minWidth='105'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label :style="checkCaptcha(scope.row.captcha)">
              {{ scope.row.captcha }}
            </label>
          </template>
        </el-table-column>


        <el-table-column
          prop='weedo_check'
          label="WEEDOCHECK"
          minWidth='105'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label  :style="checkCaptcha(scope.row.captcha)">
              <span style="color: green" v-if="scope.row.weedo_check == 1">Valid</span>
              <span style="color: red" v-else-if="scope.row.weedo_check == 2">Rejeté</span>
              <span style="color: green" v-else-if="scope.row.weedo_check == 3">Validé en interne</span>
              <span v-else></span>
            </label>
          </template>
        </el-table-column>

        <el-table-column
          prop="interne_check"
          label="Interne Check"
          minWidth="105"
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label>
              <span style="color: red" v-if="scope.row.interne_check == 0">Non</span>
              <span style="color: green" v-else-if="scope.row.interne_check == 1">Oui</span>
              <span v-else></span>
            </label>
          </template>
        </el-table-column>


        <el-table-column
          prop="trustfull_check"
          label="Trustful"
          minWidth="105"
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label>
              <span style="color: red" v-if="scope.row.trustfull_check == 1">Very Low</span>
              <span style="color: orange" v-else-if="scope.row.trustfull_check == 2">Low</span>
              <span style="color: blue" v-else-if="scope.row.trustfull_check == 3">Review</span>
              <span style="color: #00a8ff" v-else-if="scope.row.trustfull_check == 6">Review OK</span>
              <span style="color: green" v-else-if="scope.row.trustfull_check == 4">High</span>
              <span style="color: darkgreen" v-else-if="scope.row.trustfull_check == 5">Very High</span>
              <span v-else></span>
            </label>
          </template>
        </el-table-column>


        <!--        <el-table-column-->
<!--          prop='oneytrust'-->
<!--          label="oneytrust"-->
<!--          minWidth='105'-->
<!--          show-overflow-tooltip-->
<!--          sortable-->
<!--        >-->
<!--          <template scope="scope">-->
<!--            <label  :style="checkCaptcha(scope.row.captcha)">-->
<!--              <span style="color: #800000" v-if="scope.row.oneytrust == 0">Continuer prudemment</span>-->
<!--              <span style="color: #ff8e47" v-else-if="scope.row.oneytrust == 1">Continuer</span>-->
<!--              <span style="color: #37ff00" v-else-if="scope.row.oneytrust == 2">Validé</span>-->
<!--              <span style="color: red" v-else-if="scope.row.oneytrust == -1">problem</span>-->
<!--              <span v-else></span>-->
<!--            </label>-->
<!--          </template>-->
<!--        </el-table-column>-->


        <el-table-column
          prop='statuts'
          label="Statuts retour"
          minWidth='105'
          show-overflow-tooltip
          sortable
        >
          <template scope="scope">
            <label  :style="checkCaptcha(scope.row.captcha)">
              <span >{{scope.row.statuts}}</span>
            </label>
          </template>
        </el-table-column>

      </el-table>
      <div
        slot="footer"
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
      >
        <div class="">
          <p class="card-category">
            {{ $t('labels.Datatable.Showing') }} {{ from + 1 }}  {{ $t('labels.Datatable.to') }} {{ to }} {{ $t('labels.Datatable.of') }} {{ total }} {{ $t('labels.Datatable.entries') }}
          </p>
        </div>
        <base-pagination
          type="market"
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        >
        </base-pagination>
      </div>
    </card>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from 'element-ui'
import { Table, TableColumn } from 'element-ui'
import { BasePagination } from 'src/components';
import gql from 'graphql-tag'
import Fuse from 'fuse.js';
import XLSX from 'xlsx'
import moment from 'moment'

export default {
  apollo: {
    surveillanceLeads: {
      client: 'MARKET',
      query: gql` query ($produit_id: ID, $date: String, $date_fin: String, $tags: [String], $guard_period: Boolean) {
          surveillanceLeads(produit_id: $produit_id, date: $date, date_fin: $date_fin, tags: $tags, guard_period: $guard_period) {
            pk_lead
            email
            date_collect
            telephone
            lead_type
            subid
            societe
            date_livraison
            pk_commande
            prix_vente
            filtre
            vendu
            compteur_livraison
            statut
            retourws
            captcha
            gamme
            time_new_lead
            traces
            weedo_check
            interne_check
            trustfull_check
            statuts
            traces_date
            telephone_status_type
            oneytrust
          }

          surveillanceLeadsMongustave(produit_id: $produit_id, date: $date, date_fin: $date_fin, tags: $tags, guard_period: $guard_period) {
            pk_lead
            email
            date_collect
            telephone
            lead_type
            subid
            societe
            date_livraison
            pk_commande
            prix_vente
            filtre
            vendu
            compteur_livraison
            statut
            retourws
            captcha
            gamme
            weedo_check
            interne_check
            trustfull_check
            oneytrust
          }
        }`,
      variables () {
        const variables = {
          date: this.StartDate,
          date_fin: this.EndDate,
          produit_id: this.CategorieSelects.Categorie,
          guard_period: true
        }
        if (this.tags.length) {
          variables.tags = this.tags.slice()
        }
        return variables
      },
      skip() {
        return this.SkipQuery || !!this.periodBlockMessage
      },
      result({ data, loader, networkStatus }) {
        this.SkipQuery = true
        this.apiErrorMessage = ''
        // default sort pk_lead
        let All_leads = data.surveillanceLeads ? data.surveillanceLeads.concat(data.surveillanceLeadsMongustave) : data.surveillanceLeadsMongustave;

        All_leads.sort((a,b) => (parseInt(a.pk_lead) < parseInt(b.pk_lead)) ? 1 : ((parseInt(b.pk_lead) < parseInt(a.pk_lead)) ? -1 : 0));
        // default sort pk_lead
        this.Leads = this.searchLeads = All_leads
        this.fuseSearch = new Fuse(this.searchLeads, this.options);
      },
      error(error) {
        this.SkipQuery = true
        const messages = (error.graphQLErrors || []).map(item => item.message).filter(Boolean)
        this.apiErrorMessage = messages.join('\n') || error.message || ''
        if (this.apiErrorMessage) {
          this.$notify({ type: 'warning', message: this.apiErrorMessage })
        }
      },
      fetchPolicy: 'network-only',
      update: data => data
    },
    produits: {
      client: 'MARKET',
      query: gql` query {
          produits {
            pk_categorie
            designation
          }

        }`,
      result({ data, loader, networkStatus }) {
        this.CategorieSelects.ListCategorie = []
        this.CategorieSelects.ListCategorie = data.produits
        /// add Credit Conso
        const newCategorie = [

          {
            pk_categorie: 101,
            designation: 'MELEINE'
          },
          {
            pk_categorie: 103,
            designation: 'SMATIS'
          },
          {
            pk_categorie: 106,
            designation: 'ASA assurances'
          },
          {
            pk_categorie: 102,
            designation: 'WEEDO GOREG'
          },
          {
            pk_categorie: 104,
            designation: 'CARAC'
          },
          {
            pk_categorie: 105,
            designation: 'Fidel Ami sante'
          }
          ,
          {
            pk_categorie: 107,
            designation: 'Malussia'
          }
          ,
          {
            pk_categorie: 108,
            designation: 'IKI Assurances'
          }
          ,
          {
            pk_categorie: 109,
            designation: 'Mutuelles du soleil'
          }
        ];
         this.CategorieSelects.ListCategorie = [...this.CategorieSelects.ListCategorie, ...newCategorie].sort((a, b) => a.designation.localeCompare(b.designation));

      },
      update: data => data
    }
  },
  watch: {
    searchQuery(value) {
      let result = this.Leads;
      if (value != '' && this.fuseSearch) {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchLeads = result;
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchLeads.length
    },
    periodDays() {
      if (!this.StartDate || !this.EndDate) return null
      const start = moment(this.StartDate, 'YYYY-MM-DD', true)
      const end = moment(this.EndDate, 'YYYY-MM-DD', true)
      if (!start.isValid() || !end.isValid()) return null
      return end.startOf('day').diff(start.startOf('day'), 'days') + 1
    },
    periodBlockMessage() {
      const days = this.periodDays
      if (days == null) return ''
      if (days < 1) return 'La date de fin est antérieure à la date de début'
      if (!this.tags.length && days > 3) return '3 jours maximum sans tag'
      if (this.tags.length && days > 31) return '31 jours maximum avec tags'
      return ''
    }
  },
  data() {
    return {
      fuseSearch: null,
      SkipQuery: false,
      searchLeads: [],
      Leads: [],
      searchQuery: '',
      StartDate: '',
      EndDate: '',
      tags: [],
      tagInput: '',
      apiErrorMessage: '',
      CategorieSelects: {
        Categorie: 1,
        ListCategorie: []
      },
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [50, 100, 250, 500],
        total: 0
      },
      options : {
        threshold: 0,
        keys: [
          "pk_lead",
          "email",
          "telephone",
          "date_collect",
          "lead_type",
          "subid",
          "societe",
          "date_livraison",
          "pk_commande",
          "prix_vente",
          "filtre",
          "vendu",
          "retourws",
          "captcha"
        ]
      },
    }
  },
  methods: {
    focusTagInput() {
      if (this.$apollo.queries.surveillanceLeads.loading) return
      if (this.$refs.tagInput) this.$refs.tagInput.focus()
    },
    addTag() {
      const tag = (this.tagInput || '').trim()
      this.tagInput = ''
      if (!tag || this.tags.indexOf(tag) !== -1) return
      this.tags.push(tag)
    },
    removeTag(tag) {
      this.tags = this.tags.filter(item => item !== tag)
    },
    search() {
      if (this.periodBlockMessage) return
      this.apiErrorMessage = ''
      this.SkipQuery = false
    },
    DownloadCSV() {
      if (this.searchLeads.length) {
        let LeadsArray = JSON.parse(JSON.stringify(this.searchLeads));
        LeadsArray.forEach(function(v){
          if (v.prix_vente === 'OK') {
            v.prix_vente = ''
          }

          if(v.weedo_check == 1)
          {
            v.weedo_check = "Valid";
          }else  if(v.weedo_check == 2)
          {
            v.weedo_check = "Rejeté";
          }else  if(v.weedo_check == 3)
          {
            v.weedo_check = "Validé en interne";
          }else {
            v.weedo_check = "Problème";
          }

          if(v.oneytrust  == 0)
          {
            v.oneytrust = "Continuer prudemment";
          }
          else if(v.oneytrust  == 1)
          {
            v.oneytrust = "Continuer";
          }else  if(v.oneytrust == 2)
          {
            v.oneytrust = "Validé";
          }else {
            v.oneytrust = "";
          }

          if (v.interne_check == 1) {
            v.interne_check = "Oui";
          } else if (v.interne_check == 0) {
            v.interne_check = "Non";
          } else {
            v.interne_check = "";
          }

           if (v.trustfull_check == 1) {
            v.trustfull_check = "Very Low";
          } else if (v.trustfull_check == 2) {
            v.trustfull_check = "Low";
          } else if (v.trustfull_check == 3) {
            v.trustfull_check = "Review";
          } else if (v.trustfull_check == 6) {
            v.trustfull_check = "Review OK";
          } else if (v.trustfull_check == 4) {
            v.trustfull_check = "High";
          } else if (v.trustfull_check == 5) {
            v.trustfull_check = "Very High";
          } else {
            v.trustfull_check = "";
          }


          delete v.__typename
        });
        const fileName = 'surveillanceLeads.csv'
        var Leads = XLSX.utils.json_to_sheet(LeadsArray)
        Leads = XLSX.utils.sheet_to_csv(Leads, {FS:";"});

        Leads = Leads.replace("pk_lead","N° de lead")
        Leads = Leads.replace("date_collect","date collecte")
        Leads = Leads.replace("subid","tag")
        Leads = Leads.replace("date_livraison","date livraison")
        Leads = Leads.replace("lead_type","type")
        Leads = Leads.replace("pk_commande","commande")

        Leads = Leads.replace("prix_vente","prix de vente")
        var blob = new Blob(["\ufeff", Leads]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        this.sendNotif();
      }
    },
    sendNotif() {
        const urlApi = "https://apileadmarket.wee-do-it.net";
        const formData = new FormData();
        const token = localStorage.getItem("token_jwt")
        formData.append('interface', "SURVEILLANCE ACHAT & VENTE")

        this.axios
            .post(`${urlApi}/api/send-notif-data`, formData, {
            headers: {
                    'authorization': `Bearer ${token}`
                    }
            })
            .then(response => {
            console.log('Notification envoyée avec succès');
            })
            .catch(error => {
            console.error('Erreur lors de l\'envoi de la notification:', error);
            });
    },
    checkCaptcha(captcha) {
      if (captcha === "NON") {
        return "color: red;"
      }
      return "";
    }
  },
}
</script>

<style>
.booking-table-rows {
  text-transform: uppercase;
}
.customtable_cmd .cell{
  word-break: break-word;
}
.el-table .caret-wrapper {
  width: auto
}
.surveillance-tags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-height: 42px;
  max-width: 100%;
  box-sizing: border-box;
  padding: 6px 8px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 0.4285rem;
  background: transparent;
  cursor: text;
}
.surveillance-tags.is-disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
.surveillance-tag {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  box-sizing: border-box;
  background: #e6e6e6;
  color: #000;
  border-radius: 4px;
  padding: 3px 4px 3px 8px;
  font-size: 13px;
  line-height: 1.35;
  text-transform: none;
}
.surveillance-tag-label {
  min-width: 0;
  color: #000;
  overflow-wrap: anywhere;
  word-break: break-word;
}
.surveillance-tag-remove {
  flex: 0 0 auto;
  margin-left: 6px;
  border: 0;
  background: transparent;
  color: #000;
  font-size: 16px;
  line-height: 1;
  padding: 0 2px;
  cursor: pointer;
}
.surveillance-tag-remove:disabled {
  cursor: not-allowed;
}
.surveillance-tag-input {
  flex: 1 1 140px;
  min-width: 120px;
  width: auto;
  height: 28px;
  border: 0;
  outline: none;
  background: transparent;
  color: #fff;
  box-shadow: none;
  padding: 0 4px;
}
.surveillance-tag-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
</style>
